import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFileImages = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 165,
	height: 216,
	viewBox: "0 0 165 216",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .3,
			children: /* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M139.67 49.25C134.2 49.2447 128.956 47.0695 125.088 43.2018C121.22 39.3341 119.045 34.0898 119.04 28.62V0H26.9099C19.7729 0 12.9282 2.83511 7.88159 7.88171C2.83499 12.9283 0 19.7729 0 26.9099V189.09C0 192.624 0.695986 196.123 2.04834 199.388C3.40069 202.653 5.38277 205.619 7.88159 208.118C10.3804 210.617 13.3469 212.599 16.6118 213.952C19.8767 215.304 23.376 216 26.9099 216H137.51C144.647 216 151.491 213.165 156.538 208.118C161.585 203.072 164.42 196.227 164.42 189.09V49.25H139.67Z",
				fill: "#00C650"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.42 49.25H139.67C134.2 49.2447 128.956 47.0695 125.088 43.2018C121.22 39.3341 119.045 34.0898 119.04 28.62V0L164.42 49.25Z",
			fill: "#00C650"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104.3 146.41H60.1699C55.8459 146.405 51.7004 144.685 48.6428 141.627C45.5853 138.57 43.8652 134.424 43.8599 130.1V85.9301C43.8652 81.6069 45.5857 77.4626 48.6436 74.4066C51.7014 71.3506 55.8468 69.6328 60.1699 69.6301H104.34C108.661 69.6354 112.804 71.3543 115.86 74.41C118.916 77.4657 120.635 81.6087 120.64 85.9301V130.09C120.64 132.235 120.217 134.359 119.396 136.34C118.574 138.321 117.37 140.121 115.853 141.637C114.335 143.153 112.534 144.355 110.552 145.174C108.569 145.993 106.445 146.413 104.3 146.41ZM60.1699 76.8401C57.759 76.8427 55.4474 77.8009 53.7417 79.5048C52.036 81.2086 51.0751 83.5191 51.0698 85.9301V130.09C51.0725 132.503 52.0323 134.816 53.7383 136.522C55.4443 138.228 57.7573 139.187 60.1699 139.19H104.34C106.751 139.185 109.061 138.224 110.765 136.518C112.469 134.813 113.427 132.501 113.43 130.09V85.92C113.427 83.51 112.469 81.1995 110.765 79.4954C109.061 77.7912 106.75 76.8327 104.34 76.8301L60.1699 76.8401Z",
			fill: "#00C650"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117 121.7V130.1C117 133.468 115.662 136.698 113.28 139.08C110.899 141.462 107.668 142.8 104.3 142.8H60.1699C58.5013 142.801 56.8489 142.474 55.3069 141.836C53.7649 141.198 52.3635 140.263 51.1831 139.084C50.0027 137.904 49.0664 136.504 48.4275 134.962C47.7886 133.421 47.46 131.769 47.46 130.1V116.02C54.54 114.5 65.3099 114.02 78.3799 119.25L86.48 111.52L92 125.52C92 125.52 93.48 120.37 98.26 121.1C103.04 121.83 110.78 124.42 114.09 122.21C114.968 121.698 116 121.517 117 121.7Z",
			fill: "#00C650"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.53 94.9501C104.242 94.9501 106.44 92.7518 106.44 90.04C106.44 87.3283 104.242 85.1301 101.53 85.1301C98.8181 85.1301 96.6199 87.3283 96.6199 90.04C96.6199 92.7518 98.8181 94.9501 101.53 94.9501Z",
			fill: "#00C650"
		})
	]
});
export default SvgIconFileImages;
